export const p6MathsData = {
  title: "小學六年級數學",
  description: "Primary 6 Mathematics Curriculum",
  grade: "P6",
  year: "2017",
  topics: [
    {
      id: "p6-01",
      code: "P6-01",
      title: "數與代數 - 分數",
      description: "分數的運算和應用",
      objectives: [
        "理解分數的加減乘除運算",
        "掌握分數與小數的互換",
        "解決涉及分數的實際問題",
        "理解分數的比較和排序"
      ],
      sampleQuestions: [
        {
          id: "p6-01-q1",
          question: "計算：2/3 + 1/4 = ?",
          answer: "11/12",
          solution: "步驟1：找出最小公倍數\n2/3 = 8/12\n1/4 = 3/12\n步驟2：相加\n8/12 + 3/12 = 11/12",
          difficulty: "medium"
        },
        {
          id: "p6-01-q2",
          question: "計算：3/4 × 2/5 = ?",
          answer: "3/10",
          solution: "步驟1：分子相乘\n3 × 2 = 6\n步驟2：分母相乘\n4 × 5 = 20\n步驟3：化簡\n6/20 = 3/10",
          difficulty: "medium"
        },
        {
          id: "p6-01-q3",
          question: "將 0.75 化為分數",
          answer: "3/4",
          solution: "步驟1：0.75 = 75/100\n步驟2：化簡\n75/100 = 3/4",
          difficulty: "easy"
        },
        {
          id: "p6-01-q4",
          question: "比較：2/3 和 3/4 哪個較大？",
          answer: "3/4",
          solution: "步驟1：通分\n2/3 = 8/12\n3/4 = 9/12\n步驟2：比較\n9/12 > 8/12\n所以 3/4 > 2/3",
          difficulty: "medium"
        },
        {
          id: "p6-01-q5",
          question: "計算：5/6 ÷ 2/3 = ?",
          answer: "5/4",
          solution: "步驟1：除數倒數\n5/6 ÷ 2/3 = 5/6 × 3/2\n步驟2：相乘\n5/6 × 3/2 = 15/12 = 5/4",
          difficulty: "hard"
        }
      ]
    },
    {
      id: "p6-02",
      code: "P6-02",
      title: "數與代數 - 小數",
      description: "小數的運算和應用",
      objectives: [
        "掌握小數的加減乘除運算",
        "理解小數的位值概念",
        "解決涉及小數的實際問題",
        "理解小數的近似值"
      ],
      sampleQuestions: [
        {
          id: "p6-02-q1",
          question: "計算：2.5 + 1.75 = ?",
          answer: "4.25",
          solution: "步驟1：對齊小數點\n  2.50\n+ 1.75\n步驟2：相加\n  2.50\n+ 1.75\n= 4.25",
          difficulty: "easy"
        },
        {
          id: "p6-02-q2",
          question: "計算：3.6 × 2.5 = ?",
          answer: "9.0",
          solution: "步驟1：忽略小數點\n36 × 25 = 900\n步驟2：計算小數位數\n3.6 有1位小數\n2.5 有1位小數\n總共2位小數\n步驟3：加上小數點\n900 → 9.00 = 9.0",
          difficulty: "medium"
        },
        {
          id: "p6-02-q3",
          question: "計算：8.4 ÷ 2.1 = ?",
          answer: "4",
          solution: "步驟1：將除數化為整數\n8.4 ÷ 2.1 = 84 ÷ 21\n步驟2：計算\n84 ÷ 21 = 4",
          difficulty: "medium"
        },
        {
          id: "p6-02-q4",
          question: "將 3.125 四捨五入到小數點後兩位",
          answer: "3.13",
          solution: "步驟1：看第三位小數\n3.125 的第三位是 5\n步驟2：四捨五入\n5 ≥ 5，所以進位\n3.125 → 3.13",
          difficulty: "easy"
        },
        {
          id: "p6-02-q5",
          question: "計算：0.8 × 0.25 × 10 = ?",
          answer: "2",
          solution: "步驟1：先算 0.8 × 0.25\n0.8 × 0.25 = 0.2\n步驟2：再乘以 10\n0.2 × 10 = 2",
          difficulty: "medium"
        }
      ]
    },
    {
      id: "p6-03",
      code: "P6-03",
      title: "數與代數 - 百分數",
      description: "百分數的計算和應用",
      objectives: [
        "理解百分數的概念",
        "掌握百分數與分數、小數的互換",
        "解決涉及百分數的實際問題",
        "理解百分數的增減"
      ],
      sampleQuestions: [
        {
          id: "p6-03-q1",
          question: "將 3/4 化為百分數",
          answer: "75%",
          solution: "步驟1：化為小數\n3/4 = 0.75\n步驟2：化為百分數\n0.75 × 100% = 75%",
          difficulty: "easy"
        },
        {
          id: "p6-03-q2",
          question: "計算：80 的 15% 是多少？",
          answer: "12",
          solution: "步驟1：15% = 0.15\n步驟2：計算\n80 × 0.15 = 12",
          difficulty: "medium"
        },
        {
          id: "p6-03-q3",
          question: "某商品原價 200 元，現打八折，售價是多少？",
          answer: "160 元",
          solution: "步驟1：八折 = 80%\n步驟2：計算\n200 × 80% = 200 × 0.8 = 160",
          difficulty: "medium"
        },
        {
          id: "p6-03-q4",
          question: "某班有 40 人，其中 60% 是女生，女生有多少人？",
          answer: "24 人",
          solution: "步驟1：60% = 0.6\n步驟2：計算\n40 × 0.6 = 24",
          difficulty: "medium"
        },
        {
          id: "p6-03-q5",
          question: "某數增加 20% 後是 120，原數是多少？",
          answer: "100",
          solution: "步驟1：設原數為 x\n步驟2：列方程\nx × (1 + 20%) = 120\nx × 1.2 = 120\n步驟3：解方程\nx = 120 ÷ 1.2 = 100",
          difficulty: "hard"
        }
      ]
    },
    {
      id: "p6-04",
      code: "P6-04",
      title: "數與代數 - 代數",
      description: "簡單的代數運算",
      objectives: [
        "理解代數符號的意義",
        "掌握簡單的代數運算",
        "解決簡單的代數方程",
        "理解代數表達式"
      ],
      sampleQuestions: [
        {
          id: "p6-04-q1",
          question: "化簡：2x + 3x = ?",
          answer: "5x",
          solution: "步驟1：同類項相加\n2x + 3x = (2 + 3)x = 5x",
          difficulty: "easy"
        },
        {
          id: "p6-04-q2",
          question: "解方程：x + 5 = 12",
          answer: "x = 7",
          solution: "步驟1：兩邊減 5\nx + 5 - 5 = 12 - 5\n步驟2：化簡\nx = 7",
          difficulty: "easy"
        },
        {
          id: "p6-04-q3",
          question: "解方程：3x = 15",
          answer: "x = 5",
          solution: "步驟1：兩邊除以 3\n3x ÷ 3 = 15 ÷ 3\n步驟2：化簡\nx = 5",
          difficulty: "medium"
        },
        {
          id: "p6-04-q4",
          question: "化簡：2(x + 3) = ?",
          answer: "2x + 6",
          solution: "步驟1：分配律\n2(x + 3) = 2 × x + 2 × 3\n步驟2：化簡\n2x + 6",
          difficulty: "medium"
        },
        {
          id: "p6-04-q5",
          question: "解方程：2x + 3 = 11",
          answer: "x = 4",
          solution: "步驟1：兩邊減 3\n2x + 3 - 3 = 11 - 3\n2x = 8\n步驟2：兩邊除以 2\n2x ÷ 2 = 8 ÷ 2\nx = 4",
          difficulty: "medium"
        }
      ]
    },
    {
      id: "p6-05",
      code: "P6-05",
      title: "度量、圖形與空間 - 面積",
      description: "各種圖形的面積計算",
      objectives: [
        "掌握長方形、正方形、三角形、平行四邊形的面積公式",
        "理解面積的單位換算",
        "解決涉及面積的實際問題",
        "理解複合圖形的面積計算"
      ],
      sampleQuestions: [
        {
          id: "p6-05-q1",
          question: "長方形的長是 8 厘米，寬是 5 厘米，面積是多少？",
          answer: "40 平方厘米",
          solution: "步驟1：面積公式\n面積 = 長 × 寬\n步驟2：計算\n面積 = 8 × 5 = 40",
          difficulty: "easy"
        },
        {
          id: "p6-05-q2",
          question: "三角形的底是 6 厘米，高是 4 厘米，面積是多少？",
          answer: "12 平方厘米",
          solution: "步驟1：面積公式\n面積 = 底 × 高 ÷ 2\n步驟2：計算\n面積 = 6 × 4 ÷ 2 = 12",
          difficulty: "medium"
        },
        {
          id: "p6-05-q3",
          question: "平行四邊形的底是 10 厘米，高是 3 厘米，面積是多少？",
          answer: "30 平方厘米",
          solution: "步驟1：面積公式\n面積 = 底 × 高\n步驟2：計算\n面積 = 10 × 3 = 30",
          difficulty: "medium"
        },
        {
          id: "p6-05-q4",
          question: "正方形的邊長是 7 厘米，面積是多少？",
          answer: "49 平方厘米",
          solution: "步驟1：面積公式\n面積 = 邊長 × 邊長\n步驟2：計算\n面積 = 7 × 7 = 49",
          difficulty: "easy"
        },
        {
          id: "p6-05-q5",
          question: "梯形上底 4 厘米，下底 8 厘米，高 5 厘米，面積是多少？",
          answer: "30 平方厘米",
          solution: "步驟1：面積公式\n面積 = (上底 + 下底) × 高 ÷ 2\n步驟2：計算\n面積 = (4 + 8) × 5 ÷ 2 = 30",
          difficulty: "hard"
        }
      ]
    },
    {
      id: "p6-06",
      code: "P6-06",
      title: "度量、圖形與空間 - 體積",
      description: "立體圖形的體積計算",
      objectives: [
        "掌握長方體、正方體的體積公式",
        "理解體積的單位換算",
        "解決涉及體積的實際問題",
        "理解容積的概念"
      ],
      sampleQuestions: [
        {
          id: "p6-06-q1",
          question: "長方體的長是 6 厘米，寬是 4 厘米，高是 3 厘米，體積是多少？",
          answer: "72 立方厘米",
          solution: "步驟1：體積公式\n體積 = 長 × 寬 × 高\n步驟2：計算\n體積 = 6 × 4 × 3 = 72",
          difficulty: "easy"
        },
        {
          id: "p6-06-q2",
          question: "正方體的邊長是 5 厘米，體積是多少？",
          answer: "125 立方厘米",
          solution: "步驟1：體積公式\n體積 = 邊長³\n步驟2：計算\n體積 = 5³ = 125",
          difficulty: "medium"
        },
        {
          id: "p6-06-q3",
          question: "某水箱長 2 米，寬 1.5 米，高 1 米，容積是多少升？",
          answer: "3000 升",
          solution: "步驟1：計算體積（立方米）\n體積 = 2 × 1.5 × 1 = 3 立方米\n步驟2：轉換單位\n1 立方米 = 1000 升\n3 立方米 = 3000 升",
          difficulty: "medium"
        },
        {
          id: "p6-06-q4",
          question: "某立方體的體積是 64 立方厘米，邊長是多少？",
          answer: "4 厘米",
          solution: "步驟1：設邊長為 x\n步驟2：列方程\nx³ = 64\n步驟3：解方程\nx = ∛64 = 4",
          difficulty: "hard"
        },
        {
          id: "p6-06-q5",
          question: "長方體的體積是 120 立方厘米，長是 8 厘米，寬是 5 厘米，高是多少？",
          answer: "3 厘米",
          solution: "步驟1：體積公式\n體積 = 長 × 寬 × 高\n步驟2：列方程\n120 = 8 × 5 × 高\n120 = 40 × 高\n步驟3：解方程\n高 = 120 ÷ 40 = 3",
          difficulty: "medium"
        }
      ]
    },
    {
      id: "p6-07",
      code: "P6-07",
      title: "度量、圖形與空間 - 圓",
      description: "圓的周長和面積",
      objectives: [
        "理解圓的基本概念",
        "掌握圓的周長公式",
        "掌握圓的面積公式",
        "解決涉及圓的實際問題"
      ],
      sampleQuestions: [
        {
          id: "p6-07-q1",
          question: "圓的半徑是 7 厘米，周長是多少？（π = 3.14）",
          answer: "43.96 厘米",
          solution: "步驟1：周長公式\n周長 = 2πr\n步驟2：計算\n周長 = 2 × 3.14 × 7 = 43.96",
          difficulty: "medium"
        },
        {
          id: "p6-07-q2",
          question: "圓的半徑是 5 厘米，面積是多少？（π = 3.14）",
          answer: "78.5 平方厘米",
          solution: "步驟1：面積公式\n面積 = πr²\n步驟2：計算\n面積 = 3.14 × 5² = 3.14 × 25 = 78.5",
          difficulty: "medium"
        },
        {
          id: "p6-07-q3",
          question: "圓的直徑是 12 厘米，周長是多少？（π = 3.14）",
          answer: "37.68 厘米",
          solution: "步驟1：求半徑\n半徑 = 直徑 ÷ 2 = 12 ÷ 2 = 6\n步驟2：計算周長\n周長 = 2πr = 2 × 3.14 × 6 = 37.68",
          difficulty: "medium"
        },
        {
          id: "p6-07-q4",
          question: "圓的面積是 50.24 平方厘米，半徑是多少？（π = 3.14）",
          answer: "4 厘米",
          solution: "步驟1：面積公式\n面積 = πr²\n步驟2：列方程\n50.24 = 3.14 × r²\n步驟3：解方程\nr² = 50.24 ÷ 3.14 = 16\nr = √16 = 4",
          difficulty: "hard"
        },
        {
          id: "p6-07-q5",
          question: "圓的周長是 31.4 厘米，面積是多少？（π = 3.14）",
          answer: "78.5 平方厘米",
          solution: "步驟1：求半徑\n周長 = 2πr\n31.4 = 2 × 3.14 × r\nr = 31.4 ÷ (2 × 3.14) = 5\n步驟2：計算面積\n面積 = πr² = 3.14 × 5² = 78.5",
          difficulty: "hard"
        }
      ]
    },
    {
      id: "p6-08",
      code: "P6-08",
      title: "數據處理 - 統計",
      description: "數據的收集、整理和表示",
      objectives: [
        "理解數據的收集方法",
        "掌握數據的整理和分類",
        "理解各種統計圖表",
        "解決涉及統計的實際問題"
      ],
      sampleQuestions: [
        {
          id: "p6-08-q1",
          question: "某班 30 名學生的身高（厘米）如下：\n150, 152, 148, 155, 153, 149, 151, 154, 150, 152,\n153, 151, 149, 154, 150, 152, 148, 155, 153, 151,\n150, 152, 154, 149, 151, 153, 150, 152, 148, 155\n求平均身高。",
          answer: "151.5 厘米",
          solution: "步驟1：計算總和\n總和 = 4545\n步驟2：計算平均\n平均 = 4545 ÷ 30 = 151.5",
          difficulty: "medium"
        },
        {
          id: "p6-08-q2",
          question: "某商店一週的銷售額（萬元）如下：\n週一：2.5，週二：3.2，週三：2.8，週四：3.5，週五：4.1，週六：5.2，週日：4.8\n求平均日銷售額。",
          answer: "3.73 萬元",
          solution: "步驟1：計算總和\n總和 = 2.5 + 3.2 + 2.8 + 3.5 + 4.1 + 5.2 + 4.8 = 26.1\n步驟2：計算平均\n平均 = 26.1 ÷ 7 = 3.73",
          difficulty: "medium"
        },
        {
          id: "p6-08-q3",
          question: "某班學生最喜歡的科目調查結果：\n數學：15 人，中文：12 人，英文：8 人，科學：10 人\n求喜歡數學的學生佔全班人數的百分比。",
          answer: "33.33%",
          solution: "步驟1：計算總人數\n總人數 = 15 + 12 + 8 + 10 = 45\n步驟2：計算百分比\n百分比 = (15 ÷ 45) × 100% = 33.33%",
          difficulty: "medium"
        },
        {
          id: "p6-08-q4",
          question: "某班 20 名學生的測驗分數：\n85, 92, 78, 95, 88, 90, 82, 87, 91, 89,\n84, 93, 79, 86, 90, 88, 92, 85, 87, 91\n求中位數。",
          answer: "88",
          solution: "步驟1：排序\n78, 79, 82, 84, 85, 85, 86, 87, 87, 88, 88, 89, 90, 90, 91, 91, 92, 92, 93, 95\n步驟2：找中位數\n第10個和第11個數的平均值\n(88 + 88) ÷ 2 = 88",
          difficulty: "hard"
        },
        {
          id: "p6-08-q5",
          question: "某工廠一週的產量（件）：\n週一：120，週二：135，週三：110，週四：140，週五：125，週六：130，週日：115\n求眾數。",
          answer: "無眾數",
          solution: "步驟1：統計各數出現次數\n120: 1次，135: 1次，110: 1次，140: 1次，125: 1次，130: 1次，115: 1次\n步驟2：判斷\n每個數都只出現1次，所以無眾數",
          difficulty: "medium"
        }
      ]
    }
  ]
}; 